<template>
  <DropdownMenuItem
    v-bind="forwardedProps"
    :class="
      cn(
        'tw-relative tw-flex tw-cursor-pointer tw-select-none tw-items-center tw-rounded-sm tw-gap-2 tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-muted data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 tw- [&>svg]:tw-size-4 [&>svg]:tw-shrink-0',
        inset && 'tw-pl-8',
        props.class
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>

<script setup lang="ts">
import { cn } from "@/components/ui/utils"
import { DropdownMenuItem, type DropdownMenuItemProps, useForwardProps } from "radix-vue"
import { computed, type HTMLAttributes } from "vue"

const props = defineProps<DropdownMenuItemProps & { class?: HTMLAttributes["class"]; inset?: boolean }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>
